import React, { useEffect, useState } from "react";
import {
    Button,
    Card,
    Input,
    Tag,
    Row,
    Col,
    Typography,
    Space,
    Statistic,
    Descriptions,
    Modal,
    Tooltip,
    Dropdown,
} from "antd";
import { ReloadOutlined, PhoneOutlined, LinkOutlined, CopyOutlined, CommentOutlined, DownOutlined, FileExcelOutlined, FileDoneOutlined } from "@ant-design/icons";
import Table from "../../../../../core/common/dataTable";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { all_routes } from "../../../../router/all_routes";
import * as XLSX from "xlsx";
import api from "../../../../../core/axios/axiosInstance";
import { useSelector } from "react-redux";
import { fetchApprovedTemplates } from "../../../../../core/data/redux/slices/ApprovedTemplatesSlice";
import { useDispatch } from "react-redux";

const { Title, Text } = Typography;


const WabaCampaignDetails = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch()
    const [campaignData, setCampaignData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedMessage, setSelectedMessage] = useState(null);
      const userProfile = useSelector((state) => state.profile);
    
      const isWhatsappConnected =
        userProfile?.accounts?.whatsapp?.isConnected;

    const route = all_routes

    const { data: approvedTemplatesData, loading: approvedTemplatesLoading } =
        useSelector((state) => state.approvedTemplates);
    useEffect(() => {
        dispatch(fetchApprovedTemplates());
    }, [dispatch]);

    const location = useLocation()
    const selectedCampaign =
        location.state?.record

    useEffect(() => {
        const fetchCampaignById = async () => {
            try {
                const payload = {
                    campaignId: selectedCampaign.campaignId
                }
                const response = await api.post("api/whatsapp/campaignsById", payload)
                console.log(response.data, "response from get campaign by id");

            } catch (error) {

            }
        }

        fetchCampaignById()
    }, [])

    const fetchCampaignById = async () => {
        if (!selectedCampaign?.campaignId) return;
        try {
            setLoading(true);
            const response = await api.post("api/whatsapp/campaignsById", {
                campaignId: selectedCampaign.campaignId,
            });
            if (response.data.success) {
                setCampaignData(response.data);
            }
        } catch (error) {
            console.error("Error fetching campaign details", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchCampaignById();
    }, [selectedCampaign]);

    const matchedTemplate = approvedTemplatesData?.find(
  (t) => t._id === selectedCampaign?.templateId
);


const headerComponent = matchedTemplate?.components?.find(
  (c) => c.type === "HEADER"
);

const bodyComponent = matchedTemplate?.components?.find(
  (c) => c.type === "BODY"
);

const footerComponent = matchedTemplate?.components?.find(
  (c) => c.type === "FOOTER"
);

const buttonsComponent = matchedTemplate?.components?.find(
  (c) => c.type === "BUTTONS"
);

const getBtnIcon = (type) => {
  if (type === "PHONE_NUMBER") return <PhoneOutlined />;
  if (type === "URL") return <LinkOutlined />;
  if (type === "COPY_CODE") return <CopyOutlined />;
  return <CommentOutlined />;
};





const headerFormat = headerComponent?.format?.toLowerCase();
const headerMediaUrl = headerComponent?.media?.s3Url;

const renderHeader = () => {
  if (!headerComponent) return null;

  if (headerFormat === "text" && headerComponent.text) {
    return (
      <div style={{ fontWeight: 700, marginBottom: 12 }}>
        {headerComponent.text}
      </div>
    );
  }

  if (headerFormat === "image" && headerMediaUrl) {
    return (
      <img
        src={headerMediaUrl}
        alt="Header"
        style={{ width: "100%", borderRadius: 8 }}
      />
    );
  }

  if (headerFormat === "video" && headerMediaUrl) {
    return (
      <video
        src={headerMediaUrl}
        controls
        style={{ width: "100%", borderRadius: 8 }}
      />
    );
  }

  if (headerFormat === "document") {
    return (
      <div style={{ padding: 12, border: "1px solid #ddd", borderRadius: 8 }}>
        📄 {headerComponent.media?.fileName || "Document"}
      </div>
    );
  }

  return null;
};



    const columns = [
        {
            title: "Contact",
            dataIndex: "name",
        },
        {
            title: "Phone",
            dataIndex: "phone",
        },
        {
            title: "Last Updated",
            dataIndex: "lastUpdated",
        },
        // {
        //     title: "Retries",
        //     dataIndex: "retries",
        // },
        {
            title: "Status",
            dataIndex: "status",
            render: (status) => {
                if (status === "read")
                    return <Tag color="success">Read</Tag>;
                if (status === "delivered")
                    return <Tag color="processing">Delivered</Tag>;
                if (status === "sent")
                    return <Tag color="blue">Sent</Tag>;
                if (status === "failed")
                    return <Tag color="error">Failed</Tag>;

                return <Tag>{status}</Tag>;
            },
        },
        {
            title: "",
            render: (_, record) => (
                <Button
                    type="link"
                    icon={<i className="ti ti-info-circle" />}
                    onClick={() => {
                        setSelectedMessage(record);
                        setIsModalOpen(true);
                    }}
                >
                    More Info
                </Button>
            ),
        }

    ];
    const stats = campaignData?.stats || {};
    const campaign = campaignData?.campaign || {};
    const messages = campaignData?.messages || [];



    const mappedMessages = messages.map((msg, index) => ({
        id: msg.metaMessageId || index,

        // Contact (you don’t have name from API, so use number for now)
        contact: msg.chatNumber,

        // Phone
        phone: `+${msg.chatNumber}`,

        name:msg.chatName,

        // Last Updated → deliveredAt > sentAt
        lastUpdated: msg.deliveredAt
            ? new Date(msg.deliveredAt).toLocaleString()
            : msg.sentAt
                ? new Date(msg.sentAt).toLocaleString()
                : "N/A",

        // Retries → not coming from API (so 0 for now)
        retries: 0,

        // Status
        status: msg.status,

        // Extra fields for modal
        sentAt: msg.sentAt,
        deliveredAt: msg.deliveredAt,
        readAt: msg.readAt,
        metaMessageId: msg.metaMessageId,
        error: msg.error || null,
    }));
    console.log(mappedMessages, "mappedMessagesmappedMessages");



   const handleExportCSV = () => {
  if (!campaignData) return;

  const { campaign, stats, messages } = campaignData;

  /* ---------------- Campaign Summary Section ---------------- */

  const campaignInfo = [
    ["Campaign Name", campaign?.campaignName || ""],
    ["Template", matchedTemplate?.name || campaign?.templateName || ""],
    ["Recipients", stats?.total || 0],
    [
      "Scheduled At",
      campaign?.createdAt
        ? new Date(campaign.createdAt).toLocaleString()
        : "",
    ],
    ["Total Messages", stats?.total || 0],
    ["Sent", stats?.sent || 0],
    ["Delivered", stats?.delivered || 0],
    ["Read", stats?.read || 0],
    ["Failed", stats?.failed || 0],
    [],
    ["Message Details"],
    [
      "Contact Name",
      "Phone",
      "Status",
      "Sent At",
      "Delivered At",
      "Read At",
      "Failure Reason",
    ],
  ];

  /* ---------------- Message Rows ---------------- */

  const messageRows = messages.map((msg) => [
    msg.chatName || "",
    `+${msg.chatNumber}`,
    msg.status?.toUpperCase() || "",
    msg.sentAt ? new Date(msg.sentAt).toLocaleString() : "",
    msg.deliveredAt ? new Date(msg.deliveredAt).toLocaleString() : "",
    msg.readAt ? new Date(msg.readAt).toLocaleString() : "",
    msg.status === "failed" ? (msg.error || "Unknown error") : "",
  ]);

  const finalData = [...campaignInfo, ...messageRows];

  /* ---------------- Create CSV File ---------------- */

  const ws = XLSX.utils.aoa_to_sheet(finalData);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Campaign Details");

  XLSX.writeFile(
    wb,
    `${campaign?.campaignName || "campaign"}_details.csv`
  );
};

const handleExportExcel = () => {
  if (!campaignData) return;

  const { campaign, stats, messages } = campaignData;

  const campaignInfo = [
    ["Campaign Name", campaign?.campaignName || ""],
    ["Template", matchedTemplate?.name || campaign?.templateName || ""],
    ["Recipients", stats?.total || 0],
    ["Scheduled At", campaign?.createdAt ? new Date(campaign.createdAt).toLocaleString() : ""],
    ["Total Messages", stats?.total || 0],
    ["Sent", stats?.sent || 0],
    ["Delivered", stats?.delivered || 0],
    ["Read", stats?.read || 0],
    ["Failed", stats?.failed || 0],
    [],
    ["Message Details"],
    ["Contact Name", "Phone", "Status", "Sent At", "Delivered At", "Read At", "Failure Reason"],
  ];

  const messageRows = messages.map((msg) => [
    msg.chatName || "",
    `+${msg.chatNumber}`,
    msg.status?.toUpperCase() || "",
    msg.sentAt ? new Date(msg.sentAt).toLocaleString() : "",
    msg.deliveredAt ? new Date(msg.deliveredAt).toLocaleString() : "",
    msg.readAt ? new Date(msg.readAt).toLocaleString() : "",
    msg.status === "failed" ? (msg.error || "Unknown error") : "",
  ]);

  const ws = XLSX.utils.aoa_to_sheet([...campaignInfo, ...messageRows]);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Campaign Details");

  XLSX.writeFile(wb, `${campaign?.campaignName || "campaign"}_details.xlsx`, { bookType: "xlsx" });
};






    return (
        <div className="page-wrapper">
            <div className="content">
                {isWhatsappConnected === false ? (

          <div
            style={{
              height: "70vh",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              textAlign: "center",
            }}
          >
            <h3>WhatsApp is not connected</h3>
            <p style={{ color: "#888", marginBottom: 20 }}>
              Please configure WhatsApp to start chatting.
            </p>

            <button
              className="btn btn-primary"
              onClick={() => {
                if (userProfile?.role === "companyAdmin") {
                  navigate("/whatsapp/setting");
                }
              }}
              disabled={userProfile?.role !== "companyAdmin"}
            >
              {userProfile?.role === "companyAdmin"
                ? "Go to WhatsApp Settings"
                : "Contact your Company Admin"}
            </button>
          </div>

        ) :
               <> <div className="card mt-3">
                    <div className="card-body pb-2">
                        <div className="d-flex justify-content-between align-items-center">
                            <h4 className="page-title mb-0">
                                <span onClick={() => navigate(-1)} style={{ cursor: "pointer" }}>
                                    <i className="ti ti-arrow-narrow-left me-3" />
                                </span>
                                Campaign Details
                            </h4>
                            <Space>
                                <Tooltip title="Refresh campaign status">
                                    <Button
                                        icon={<ReloadOutlined />}
                                        loading={loading}
                                        onClick={fetchCampaignById}
                                    >
                                        Refresh
                                    </Button>
                                </Tooltip>
                                <Dropdown
                                    menu={{
                                        items: [
                                            {
                                                key: "csv",
                                                icon: <FileDoneOutlined />,
                                                label: "Export as CSV",
                                                onClick: handleExportCSV,
                                            },
                                            {
                                                key: "excel",
                                                icon: <FileExcelOutlined style={{ color: "#217346" }} />,
                                                label: "Export as Excel",
                                                onClick: handleExportExcel,
                                            },
                                        ],
                                    }}
                                    trigger={["click"]}
                                >
                                    <Button type="primary" className="bg-success">
                                        Export <DownOutlined />
                                    </Button>
                                </Dropdown>
                            </Space>
                        </div>
                    </div>
                </div>

             
                <Row gutter={24}>
                    <Col span={16}>
                        <Card className="mb-4 bg-transparent">
                            <div style={{ display: "flex", gap: "8px", flexWrap: "nowrap" }}>
                                {Object.entries(stats).map(([key, value]) => (
                                    <Card
                                        key={key}
                                        className="metric-card outbound-card"
                                        hoverable
                                        style={{ flex: "0 0 20%" }}
                                    >
                                        <Space direction="vertical" size="small" style={{ width: "100%" }}>
                                            <Text type="secondary" className="metric-label fs-2">
                                                {value}
                                            </Text>
                                            <Statistic
                                                value={key.charAt(0).toUpperCase() + key.slice(1)}
                                                precision={0}
                                                className="metric-value"
                                                valueStyle={{ color: "#1890ff", fontSize: "12px" }}
                                            />
                                        </Space>
                                    </Card>
                                ))}

                            </div>
                        </Card>


                        <Card>
                            <Input.Search
                                placeholder="Search Campaigns"
                                style={{ width: 300, marginBottom: 16 }}
                            />
                            <Table
                                columns={columns}
                                dataSource={mappedMessages}
                                loading={loading}

                                rowKey="id"
                                pagination={false}
                            />
                        </Card>
                    </Col>

                    <Col span={8}>
                        <Space direction="vertical" size="large" style={{ width: "100%" }}>
                            {/* Campaign Info */}
                            <Card bodyStyle={{ padding: 0 }}> {/* Remove default padding */}
                                <Title level={5} className="ms-2 pt-3">Campaign Details</Title>

                                <Card className="mb-2" bodyStyle={{ padding: 8 }}>
                                    <Text type="secondary">Campaign Name</Text>
                                    <br />
                                    <Text strong>{campaign.campaignName}</Text>
                                </Card>

                                <Card className="mb-2" bodyStyle={{ padding: 8 }}>
                                    <Text type="secondary">Template</Text>
                                    <br />
                                    <Text strong>{campaign.templateName}</Text>
                                </Card>

                                <Card className="mb-2" bodyStyle={{ padding: 8 }}>
                                    <Text type="secondary">Recipients</Text>
                                    <br />
                                    <Text strong>{stats.total || 0}</Text>
                                </Card>

                                <Card bodyStyle={{ padding: 8 }}>
                                    <Text type="secondary">Time Scheduled</Text>
                                    <br />
                                    <Text strong>
                                        {campaign.scheduledAt
                                            ? new Date(campaign.scheduledAt).toLocaleString()
                                            : new Date(campaign.createdAt).toLocaleString()}
                                    </Text>

                                </Card>
                            </Card>

                            <Card
                                style={{
                                    backgroundImage: "url('/assets/img/wabaBg.png')",
                                    backgroundRepeat: "repeat",
                                }}
                            >
                                <div
                                    style={{
                                        background: "#fff",
                                        borderRadius: 12,
                                        padding: 14,
                                    }}
                                >
                                   

{matchedTemplate ? (
  <>
    {renderHeader()}

    {bodyComponent?.text && (
      <div style={{ marginBottom: 8 }}>
        {bodyComponent.text}
      </div>
    )}

    {footerComponent?.text && (
      <div
        style={{
          fontSize: 12,
          color: "#888",
          marginBottom: 12,
        }}
      >
        {footerComponent.text}
      </div>
    )}

    {buttonsComponent?.buttons?.map((btn, i) => (
      <Button
        key={i}
        block
        icon={getBtnIcon(btn.type)}
        style={{ marginBottom: 8 }}
      >
        {btn.type === "PHONE_NUMBER"
          ? `${btn.text}${btn.phone_number ? ` — ${btn.phone_number}` : ""}`
          : btn.type === "URL"
          ? `${btn.text}${btn.url ? ` — ${btn.url}` : ""}`
          : btn.type === "COPY_CODE"
          ? `${btn.text || "Copy Code"}${btn.example ? ` — ${btn.example}` : ""}`
          : btn.text}
      </Button>
    ))}
  </>
) : (
  <Text type="secondary">Template not found</Text>
)}






                                </div>
                            </Card>
                        </Space>
                    </Col>

                </Row>
                   </>
}
            </div>
            <Modal
                title="Message Details"
                open={isModalOpen}
                onCancel={() => {
                    setIsModalOpen(false);
                    setSelectedMessage(null);
                }}
                footer={null}
            >
                {selectedMessage && (
                    <Descriptions column={1} bordered>
                        <Descriptions.Item label="Phone">
                            {selectedMessage.phone}
                        </Descriptions.Item>

                        <Descriptions.Item label="Status">
                            <Tag
                                color={
                                    selectedMessage.status === "read"
                                        ? "success"
                                        : selectedMessage.status === "delivered"
                                            ? "processing"
                                            : selectedMessage.status === "failed"
                                                ? "error"
                                                : "default"
                                }
                            >
                                {selectedMessage.status?.toUpperCase()}
                            </Tag>
                        </Descriptions.Item>

                        <Descriptions.Item label="Sent At">
                            {selectedMessage.sentAt
                                ? new Date(selectedMessage.sentAt).toLocaleString()
                                : "N/A"}
                        </Descriptions.Item>

                        <Descriptions.Item label="Delivered At">
                            {selectedMessage.deliveredAt
                                ? new Date(selectedMessage.deliveredAt).toLocaleString()
                                : "N/A"}
                        </Descriptions.Item>
                        <Descriptions.Item label="Read At">
                            {selectedMessage.readAt
                                ? new Date(selectedMessage.readAt).toLocaleString()
                                : "N/A"}
                        </Descriptions.Item>

                        {selectedMessage.status === "failed" && (
                            <Descriptions.Item label="Failure Reason">
                                <Tag color="error" style={{ whiteSpace: "normal", wordBreak: "break-word" }}>
                                    {selectedMessage.error || "Unknown error"}
                                </Tag>
                            </Descriptions.Item>
                        )}

                    </Descriptions>
                )}
            </Modal>

        </div>
    );
};

export default WabaCampaignDetails;
